import { createResource } from '@atlassian/react-resource-router';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-knowledge-base-kb-topics", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-kb-topics" */ './get-data'
	);

type Topic = {
	topicId: string;
	aiDraftArticleGenerationState: string;
	jqlQuery: string;
	numberOfRelatedTickets: string;
	topicName: string;
};
export const servicedeskKnowledgeBaseKbTopicsResource = createResource<{ topics: Topic[] }>({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_KB_TOPICS',
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader,
	maxAge: Infinity,
	isBrowserOnly: true,
});
